import React from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { NavMenu, NavMenuItem } from "./navMenu";

interface OwnProps {
  items: NavMenuItem[];
  baseRoute: string;
  label?: string;
}

interface StateProps {
  routing: RouterReducer;
}

type Props = OwnProps & StateProps;

interface State {
  activeItem: string;
}

class RouteNavComponent extends React.Component<Props, State> {
  private rootRef = React.createRef<HTMLDivElement>();

  constructor(props: Props) {
    super(props);

    this.state = {
      activeItem: null,
    };
  }

  private setPageItemActive = () => {
    // find the item with the relevant related page and set id as activeItem
    const currentPath: string = this.props.routing && this.props.routing.locationBeforeTransitions
      ? (this.props.routing.locationBeforeTransitions as any).pathname
      : null;

    const currentItem = this.props.items.find((linkItem) => (
      linkItem.relatedPage != null
      && currentPath != null
      && currentPath.includes(linkItem.relatedPage)
    ));

    this.setState({
      activeItem: currentItem ? currentItem.id : "",
    });
  }

  public componentDidMount() {
    this.setPageItemActive();
  }

  public render() {
    const { activeItem } = this.state;
    const { label, items, baseRoute } = this.props;
    return (
      <div className="route-nav" ref={this.rootRef}>
        <NavMenu
          label={label}
          selectOnMobile={true}
          onItemClick={null}
          onSelectChange={null}
          activeItem={activeItem}
          items={items}
          baseRoute={baseRoute}
        />
      </div>
    );
  }
}

const stateToProps = (state: IWebStoreState): StateProps => {
  return {
    routing: state.routing,
  };
};

export const RouteNav = connect<StateProps, void, OwnProps>(stateToProps)(RouteNavComponent);
